import { useState, useEffect } from 'react';
import '../styles/HeroBanner.css';

const SLIDES = [
  {
    id: 'yield',
    headline: ['EARN YIELD,', 'LEND AND STAKE'],
  },
  {
    id: 'xrp',
    headline: ['YOUR XRP IS NOW', 'IN PLAY'],
  },
];

const ROTATE_MS = 5000;
const LAUNCH_XRPFI_URL =
  'https://xrpfi.flare.network/defi?_gl=1*eb84nd*_up*MQ..*_ga*NTM2MTk2NjQ4LjE3ODc4MTU5ODY.*_ga_E6JBVK9HQX*czE3ODc4MTU5ODUkbzEkZzAkdDE3ODc4MTU5ODUkajYwJGwwJGg0Mzg3NzM3OTk.';

function HeroBanner() {
  const [activeIndex, setActiveIndex] = useState(0);
  const desktopBg = `${process.env.PUBLIC_URL}/images/hero-horses.webp`;
  const mobileBg = `${process.env.PUBLIC_URL}/images/hero-horses-mobile.webp`;

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, ROTATE_MS);

    return () => clearInterval(timer);
  }, []);

  const activeSlide = SLIDES[activeIndex];

  return (
    <section className="hero-banner">
      <div
        className="hero-banner__bg hero-banner__bg--desktop"
        style={{ backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 55%, rgba(0,0,0,0.35) 100%), url(${desktopBg})` }}
      />
      <div
        className="hero-banner__bg hero-banner__bg--mobile"
        style={{ backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 100%), url(${mobileBg})` }}
      />

      <div className="hero-banner__overlay">
        <h1 className="hero-banner__headline" key={activeSlide.id}>
          {activeSlide.headline[0]}
          <br className="hero-banner__break" />
          {' '}{activeSlide.headline[1]}
        </h1>

        <div className="hero-banner__right">
          <div className="hero-banner__stat">
            <div className="hero-banner__stat-top">
              <span className="hero-banner__stat-number">148,5M</span>
              <button className="hero-banner__stat-close" aria-label="Dismiss">×</button>
            </div>
            <span className="hero-banner__stat-label">on Flare</span>
          </div>

          <a
            href={LAUNCH_XRPFI_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-banner__cta"
          >
            Launch XRPFi
          </a>
        </div>

        <div className="hero-banner__dots">
          {SLIDES.map((slide, i) => (
            <button
              key={slide.id}
              className={`hero-banner__dot ${i === activeIndex ? 'hero-banner__dot--active' : ''}`}
              aria-label={`Go to slide ${i + 1}`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroBanner;